import { format } from "@hejdoktor/resx-compiler"
export { format }
import { getLocale } from "@hejdoktor/resx-compiler"

import { R as _da } from "./ProgramsResources.da.resx"
import { R as _en } from "./ProgramsResources.en.resx"
import { R as _nb } from "./ProgramsResources.nb.resx"

type Translations = {
	"YourNextConsultation": string,
	"GoToUpcomingConsultation": string,
	"BackToBookingButtonLabel": string,
	"SundvaegtGoalCardTitle": string,
	"SundvaegtGoalCardDescription": string,
	"SundvaegtGoalCardActionButtonText": string,
	"SundvaegtGoalProgressStartLabel": string,
	"SundvaegtGoalProgressEndLabel": string,
	"SundvaegtGoalProgressWeightLabel": string,
	"SundvaegtSetWeightGoalModalTitle": string,
	"SundvaegtSetWeightGoalModalDescription": string,
	"SundvaegtSetWeightGoalModalInputLabel": string,
	"SundvaegtSetWeightGoalModalInputRequiredLabel": string,
	"SundvaegtSetWeightGoalModalSubmitButton": string,
	"SundvaegtSetWeightGoalModalInfoTitle": string,
	"SundvaegtSetWeightGoalModalInfoDescription": string,
	"SundvaegtSetWeightGoalModalValidationWeightGoalTooHigh": string,
	"SundvaegtSetWeightGoalModalValidationWeightGoalTooLow": string,
	"SundvaegtSetWeightGoalErrorMessage": string,
	"SundvaegtAddWeightLogErrorMessage": string,
	"SundvaegtEditWeightLogErrorMessage": string,
	"SundvaegtDeleteWeightLogErrorMessage": string,
	"SundvaegtSetWeightGoalInputPlaceholder": string,
	"SundvaegtProgramConfirmationLabel": string,
	"SundvaegtProgramLogWeightButtonLabel": string,
	"SundvaegtAddWeightLogModalTitle": string,
	"SundvaegtAddWeightLogModalInputLabel": string,
	"SundvaegtAddWeightLogModalInputRequiredLabel": string,
	"SundvaegtAddWeightLogModalSubmitButton": string,
	"SundvaegtAddWeightLogInputPlaceholder": string,
	"SundvaegtWeightLogCardLatestWeightLossLabel": string,
	"SundvaegtWeightLogCardOverallWeightLossLabel": string,
	"SundvaegtWeightLogCardOverallWeightLossStatus": string,
	"SundvaegtWeightLogCardOverallWeightLossStatusPart1": string,
	"SundvaegtWeightLogCardOverallWeightLossStatusPart2": string,
	"SundvaegtWeightEditWeightLogLabel": string,
	"SundvaegtWeightDeleteWeightLogLabel": string,
	"SundvaegtDateInputLabel": string,
	"SundvaegtDateInputRequiredLabel": string,
	"SundvaegtPleaseEnterValidWeightLabel": string,
	"SundvaegtWeightLogChartYLabel": string,
	"SundvaegtWeightLogChartXLabel": string,
	"SundVaegtChartTooltip": string,
	"NnSundvaegtConsultationsLeft": string,
	"NnSundvaegtConsultationsExpire": string,
	"NnSundvaegtAreYouDone": string,
	"NnSundvaegtCancelProgram": string,
	"SundvaegtFeedbackTitle": string,
	"SundvaegtFeedbackDescription": string,
	"SundvaegtFeedbackButtonLabel": string,
	"EditGoalWeight": string,
	"ArticlesHeader": string,
	"ShowMore": string,
	"ShowLess": string,
	"All": string,
	"MeetTheTeamHeader": string,
	"ArticleNewLabel": string,
}

const R = new Proxy({}, {
	get(target, name: keyof Translations, receiver) {
		if(process.env.enforcedLocale === "da" || (!process.env.enforcedLocale && getLocale("da") === "da")) {
			return _da[name] ?? name
		}

if(process.env.enforcedLocale === "en" || (!process.env.enforcedLocale && getLocale("da") === "en")) {
			return _en[name] ?? name
		}

if(process.env.enforcedLocale === "nb" || (!process.env.enforcedLocale && getLocale("da") === "nb")) {
			return _nb[name] ?? name
		}

		return name
	},
}) as Translations

export { R }